import { render, staticRenderFns } from "./popupRadioButton.vue?vue&type=template&id=448e5561&scoped=true"
import script from "./popupRadioButton.vue?vue&type=script&lang=js"
export * from "./popupRadioButton.vue?vue&type=script&lang=js"
import style0 from "./popupRadioButton.vue?vue&type=style&index=0&id=448e5561&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448e5561",
  null
  
)

export default component.exports